module.exports = __webpack_public_path__ + "static/media/account.9f72c13b.svg";